import React, { PureComponent } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import i18n from "i18next";

import { Modal } from "../Common";
import { Panel, PanelHeader } from "../Layout/Panel";
import { SortedList, SortedListPagination } from "../Layout/SortedList";
import { deleteNotification, getNotifications, initializeFirebaseApp } from "../../actions";
import { getIsLoadingSelector, getNotificationsSelector } from "../../selectors/selectors";
import { searchColumns, sortColumns } from "./List/searchColumns";
import { withNavigationHistory } from "../Common/Navigation/withNavigationHistory";
import HeaderSummary from "./HeaderSummary";
import ListHeader from "./List/ListHeader";
import ListRow from "./List/ListRow";

class ManageNotificationsPage extends PureComponent {
  static propTypes = {
    deleteNotification: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    isMobile: PropTypes.bool,
    notifications: PropTypes.array,
    userMetadata: PropTypes.object
  };

  static defaultProps = {
    isLoading: false,
    isMobile: false,
    notifications: [],
    userMetadata: {}
  };

  state = {
    isDeleteModalVisible: false,
    idToDelete: null,
    viewState: {
      currentPage: 1,
      searchQuery: "",
      sort: {}
    }
  };

  handleSetViewState = item => this.setState({ viewState: { ...this.state.viewState, ...item } });

  handleChangePagination = currentPage => this.handleSetViewState({ currentPage });

  handleChangeSort = sort => this.handleSetViewState({ sort });

  handleDeleteNotification = () => {
    this.props.deleteNotification(this.state.idToDelete);
    this.handleHideDeleteModal();
  };

  handleHideDeleteModal = () => this.setState({ isDeleteModalVisible: false, idToDelete: null });

  handleShowDeleteModal = idToDelete => this.setState({ isDeleteModalVisible: true, idToDelete });

  deleteButtons = [
    {
      onClose: this.handleHideDeleteModal,
      label: i18n.t("button.cancel")
    },
    {
      onClose: this.handleDeleteNotification,
      label: i18n.t("button.delete")
    }
  ];

  render() {
    return (
      <Panel className="notification__panel">
        <PanelHeader id={i18n.t("notification.manage")} isMobile={this.props.isMobile} />
        <HeaderSummary />
        <SortedList
          RowComponent={ListRow}
          PaginationComponent={SortedListPagination}
          HeaderComponent={ListHeader}
          onChangePagination={this.handleChangePagination}
          onChangeSort={this.handleChangeSort}
          noResultTitle={i18n.t("table.noNotificationsTitle")}
          noResultMessage={i18n.t("table.noNotificationsMessage")}
          currentPage={this.state.viewState.currentPage}
          data={this.props.notifications}
          isLoading={this.props.isLoading}
          isMobile={this.props.isMobile}
          rowProps={{ onDeleteClick: this.handleShowDeleteModal, userMetadata: this.props.userMetadata }}
          searchQuery={this.state.viewState.searchQuery}
          searchValues={searchColumns}
          sort={this.state.viewState.sort}
          sortValues={sortColumns}
        />

        {this.state.isDeleteModalVisible && (
          <Modal
            buttons={this.deleteButtons}
            className="--delete"
            modalClassName="--notification"
            message={i18n.t("notification.deleteNotificationMessage")}
            title={i18n.t("notification.deleteNotificationTitle")}
          />
        )}
      </Panel>
    );
  }
}

const mapStateToProps = state => {
  return {
    isLoading: getIsLoadingSelector(state, [getNotifications.id, initializeFirebaseApp.id, deleteNotification.id]),
    isMobile: state.app.isMobile,
    notifications: getNotificationsSelector(state),
    userMetadata: state.app.userMetadata
  };
};

export default connect(
  mapStateToProps,
  { deleteNotification, getNotifications }
)(withNavigationHistory(ManageNotificationsPage));



// WEBPACK FOOTER //
// ./src/components/Notifications/ManageNotificationsPage.js